import { configureStore } from "@reduxjs/toolkit";
import articleReducer from "./slices/articleSlice";

const store = configureStore({
  reducer: {
    article: articleReducer,
  },
});

export default store;
